const primitives = {
  color: {
    neutral: {
      /*
      0: "#FFFFFF",
      50: "rgba(241, 241, 241, 0.5)", // Translucent grey (0.5 alpha)
      100: "#F1F1F1",
      200: "#E1E2E2",
      300: "#D9DCDC",
      400: "#D0D0D0",
      500: "#B9B9B9",
      600: "#8A8A8A",
      700: "#787878",
      800: "#666666",
      900: "#606060",
      950: "#070707",
      */
      0: "#FFFFFF",
      50: "#FAFAFA", // Translucent grey (0.5 alpha)
      100: "#F5F5F5",
      200: "#E6E6E6",
      300: "#D3D3D3",
      400: "#B9B9B9",
      500: "#727272",
      600: "#535353",
      700: "#404040",
      800: "#272727",
      900: "#1A1A1A",
      950: "#0B0B0B",
    },
    transparent: {
      0: "#00000000", // fully transparent
      50: "#0000000D", // ~5% opacity
      100: "#0000001A", // ~10% opacity
      200: "#00000033", // ~20% opacity
    },
    teal: {
      100: "#E3F1F0",
      300: "#A4D3D0",
      500: "#4DA199", // Brand primary
      700: "#35706A",
    },
    navy: {
      300: "#7289AB",
      500: "#3C4B6D",
    },
    green: {
      50: "#E5F6E6",
      100: "#D0FFB6",
      600: "#3C875A",
      800: "#246500",
    },
    red: {
      50: "#FADBDF",
      100: "#F2BEBE",
      300: "#EC959F",
      500: "#E84D5F", // Canonical red / error
      700: "#BE3343",
    },
    yellow: {
      main: "#D8D592",
      light: "#E2E1B9",
      dark: "#D6CA62",
    },
    chartMarkers: {
      increased: "#0f990f",
      decreased: "#e93e3a",
      unchanged: "#8a8a8a",
    },
  },
  radius: {
    xxs: 1,
    xs: 2, // Icons
    sm: 4, // Buttons, small inputs
    md: 12, // Cards, boxes
    lg: 20, // Tables, status badges
    full: 9999, // Pills, scrollbars
  },
  levelColors: ["#F37350", "#842FCD", "#21D7C2", "#FABD05", "#388BEB"],
  typography: {
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
      black: 900,
    },
    size: {
      xs: "0.625rem", // 10 px
      sm: "0.75rem", // 12 px
      md: "0.875rem", // 14 px
      lg: "1rem", // 16 px
      xl: "1.25rem", // 20 px
      display: "1.5rem", // 24 px
    },
  },
};

export default primitives;
